import { SerializableObject } from './serializable-object';


/** Empty domain object, used for responses that do not return any data. */
export class EmptyResponse extends SerializableObject {
  public buildFromJSON(_json: Object) {
    // Discard all passed arguments.
  }
}
